/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import Block from "../../../atoms/layout/Block";
import {Title} from "../../../atoms/text/Title";
import {makeAvailableTagSelector} from "../../../../selectors/finder";
import {InformationIcon} from "../../../molecules/finder/InformationIcon";

export default class ButtonFilter extends React.Component {

    constructor(props) {
        super(props);

        this.tags = makeAvailableTagSelector((props) => props.filter.tags);
    }

    render() {
        const { filter, selected, toggleTag } = this.props;
        const tags = this.tags(this.props);

        if (!filter || tags.length === 0) {
            return null;
        }

        return  <Block className={`finder__filter filter-${filter.type.toLowerCase()}`}>
            { filter.title && <Block className="finder__filter-header">
                <Block className="p-flex p-justify-space-between">
                    <span className={"text-small-semi-bold"}>{filter.title}</span>
                    {filter.informationIcon && <InformationIcon message={filter.informationIcon} type="INFO"/>}
                </Block>
            </Block> }

            <Block className={`finder__filter-body`}>
                { tags.map(tag =>
                  <div
                    key={tag.id}
                    className={`radio p-filter-radio ${selected.some(({ id }) => id === tag.id) ? "p-filter-radio--selected" : ""}`}
                    onClick={() => toggleTag(tag.id)}
                  >
                        <input readOnly type="radio" name="cat"
                               checked={selected.length > 0 && selected[0].id === tag.id}/>
                        <label>
                            {tag.title}
                            <span className="p-filter-radio__icon glyphicon glyphicon-arrow-right"/>
                        </label>
                    </div>
                )}
            </Block>
        </Block>
    }


}
